<ng-container *ngIf="worksheets$ | async as worksheets; else loadingRef">
  <ng-container [ngSwitch]="pageRequested">
    <ng-container *ngSwitchCase="pageRequestedType.GALLERY">
      <ng-container *ngFor="let worksheetGroup of worksheets">
        <fgb-video-gallery [worksheetGroup]="worksheetGroup"></fgb-video-gallery>
        <div class="container text-center pt-20">
          <fgb-upgrade-banner></fgb-upgrade-banner>
          <h2 class="font-size-20 text-start header-title">{{ 'gallery.title' | translate }}</h2>
          <div class="row row-gap-20">
            <ng-container *ngFor="let item of worksheetGroup.Items">
              <ng-container *ngIf="item.WorksheetType == worksheetType.Gallery">
                <div class="col-12 {{ colOverride }}" [class.col-lg-4]="isList && !colOverride">
                  <fgb-worksheet-item
                    [worksheetItem]="item"
                    [worksheetId]="worksheetGroup.WorksheetId"
                    [galleryMode]="true"
                  ></fgb-worksheet-item>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="pageRequestedType.NEWSLETTERS">
      <ng-container *ngFor="let worksheetGroup of worksheets">
        <div class="container text-center mt-30">
          <fgb-upgrade-banner></fgb-upgrade-banner>
          <div class="row row-gap-20">
            <ng-container *ngFor="let item of worksheetGroup.Items">
              <ng-container *ngIf="item.WorksheetType == worksheetType.Download">
                <div class="{{ colOverride }} gallery-item-container" [ngClass]="isList && !colOverride ? 'col-lg-4' : ''">
                  <fgb-worksheet-item [worksheetItem]="item" [worksheetId]="worksheetGroup.WorksheetId"></fgb-worksheet-item>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="pageRequestedType.TESTIMONIALS">
      <section
        class="testimonials"
        aria-labelledby="testimonials-heading"
        *ngIf="hasWorksheetType(worksheets, worksheetType.Gallery)"
      >
        <div class="testimonials-inner">
          <h2 class="testimonials-title text-white text-uppercase mb-0" id="testimonials-heading">
            {{ 'testimonials.title' | translate : { fgbdefault: 'Testimonials' } }}
          </h2>

          <!-- One track across every group: a card per page on mobile, three across on desktop -->
          <div class="testimonials-track" #testimonialsTrack (scroll)="onTestimonialsScroll()">
            <ng-container *ngFor="let worksheetGroup of worksheets">
              <ng-container *ngFor="let item of worksheetGroup.Items">
                <ng-container *ngIf="item.WorksheetType == worksheetType.Gallery">
                  <div class="testimonial-card">
                    <div class="testimonial-image">
                      <img [src]="item.Image | contentImage : '1'" [alt]="item.Title" draggable="false" />
                    </div>
                    <div class="testimonial-body">
                      <p class="testimonial-quote mb-0">{{ item.Description }}</p>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>

          <!-- Dots only appear when the cards do not all fit on screen -->
          <div class="testimonials-dots" *ngIf="testimonialPages.length > 1">
            <button
              class="testimonials-dot"
              type="button"
              *ngFor="let page of testimonialPages"
              [attr.data-distance]="testimonialDotDistance(page)"
              [attr.aria-current]="page === activeTestimonialPage || null"
              [attr.aria-label]="'Go to testimonial ' + (page + 1)"
              (click)="goToTestimonialPage(page)"
            ></button>
          </div>
        </div>
      </section>
    </ng-container>
  </ng-container>
</ng-container>

<!-- Loading -->
<ng-template #loadingRef>
  <div class="w-100">
    <fgb-loading></fgb-loading>
  </div>
</ng-template>
